import React, { useEffect } from "react";
import { PlanCard } from "../Cards/Plans";
import { useDispatch, useSelector } from "react-redux";
import { getPlansRequest } from "../../redux/action";
import toast from "react-hot-toast";
import { CircularProgress } from "@material-ui/core";

export const PlanSection = () => {
  const dispatch = useDispatch();

  const { getPlansSuccess, getPlansError, getPlansLoading, plans } =
    useSelector((state) => {
      const {
        success: { getPlans: getPlansSuccess },
        errors: { getPlans: getPlansError },
      } = state.ajaxStatuses;

      const { getPlansLoading } = state.loadingIndicator;

      const { plans } = state.planData;

      return {
        getPlansSuccess,
        getPlansError,
        getPlansLoading,
        plans,
      };
    });

  useEffect(() => {
    if (getPlansError) {
      toast.error(getPlansError, {
        duration: 3000,
      });
    }
  }, [getPlansError]);

  useEffect(() => {
    dispatch(getPlansRequest());
  }, [dispatch]);

  return (
    <div className="overflow-scroll md:overflow-auto mt-4">
      <div className="grid grid-cols-3 w-960px  mx-auto gap-4">
        {getPlansLoading ? (
          <div className="text-center col-span-3 justify-self-center align-self-center my-36">
            <CircularProgress size="20px" />
          </div>
        ) : plans && plans.length > 0 ? (
          plans.map((plan, index) => <PlanCard plan={plan} key={index} />)
        ) : (
          <div className="text-center col-span-3 justify-self-center align-self-center my-36">
            <p className="text-gray-500">No plans available at the moment.</p>
          </div>
        )}
      </div>
    </div>
  );
};
